import ApiCustomer from "./api.customer";

export default class ApiBarman extends ApiCustomer{
    static endpoint='/shop/api/barman/';
}
